import { render, staticRenderFns } from "./zhTrigger.vue?vue&type=template&id=006e6631&scoped=true&"
import script from "./zhTrigger.vue?vue&type=script&lang=js&"
export * from "./zhTrigger.vue?vue&type=script&lang=js&"
import style0 from "./zhTrigger.vue?vue&type=style&index=0&id=006e6631&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e6631",
  null
  
)

export default component.exports